import {Injectable} from '@angular/core';
import {DateFormatService} from '../../shared/services/date-format.service';
import {Company, CompanyForm, Language} from '../models/company';
import {Address} from '../../shared/models/address';
import {Contact} from '../../shared/models/contact';
import {SubscriptionI} from '../../shared/models/subscription-i';

@Injectable({
  providedIn: 'root'
})
export class CompanyMapperService {

  constructor(private dateFormatService: DateFormatService) {}

  dbToForm(data: Company): CompanyForm {
    return {
      address: data.address,
      general: {
        name: data.name,
        vat: data.vat,
        active: data.active,
        language: {
          id: data.language ? (data.language.id ? data.language.id : null) : null,
          name: data.language ? (data.language.name ? data.language.name : null) : null,
        },
      },
      misc: {
        byForm: {
          createdBy: this.dateFormatService.stringToFullDateTime(data.created),
          updatedBy: this.dateFormatService.stringToFullDateTime(data.updated),
        },
      },
      contact: data.contact ? data.contact : null,
      billing: {
        LogisticsIdentifier: data.logisticsIdentifier,
        sapCode: data.sapCode,
        office: { id: data.officeID },
        salesId: { id: data.saleUserID },
        blocked: data.blocked,
        groupBySite: data.isGroupSiteInvoice,
      },
      uuid: data.uuid,
    }
  }

  FormToDB(data: CompanyForm): Company  {
      return {
        name: data.general.name,
        active: data.general.active,
        blocked: data.billing.blocked,
        isGroupSiteInvoice: data.billing.groupBySite,
        sapCode: data.billing.sapCode,
        address: this.addressToDB(data.address),
        contact: data.contact,
        language: { id: data.general.language.id , name: data.general.language.name },
        logisticsIdentifier: data.billing.LogisticsIdentifier,
        officeID:  data.billing.office.id,
        saleUserID: data.billing.salesId.id,
        vat: data.general.vat,
      }
  }
  // tslint:disable-next-line:no-any
  formToDbPatch(api: string, subForm: any , companyUuid: string): SubscriptionI {
    let newFormSite = null;
    switch (api) {
      case 'general':
        newFormSite = this.FormToDBGeneral(subForm);
        break;
      case 'billing':
        newFormSite = this.FormToDBGeneral(subForm);
        break;
      case 'simple':
        newFormSite = this.FormToDBSimple(subForm , companyUuid);
        break;
      case 'address':
        newFormSite = this.FormToDBAddress(subForm , companyUuid);
        break;
      case 'contact':
        newFormSite = this.FormToDBContact(subForm , companyUuid);
        break;
      default:

        return subForm;
    }
    // tslint:disable-next-line:no-console
    return newFormSite;
  }
  FormToDBGeneral(data: CompanyForm): Company  {
    return {
      name: data.general.name,
      active: data.general.active,
      blocked: data.billing.blocked,
      isGroupSiteInvoice: data.billing.groupBySite,
      sapCode: data.billing.sapCode,
      language: { id: data.general.language.id , name: data.general.language.name },
      logisticsIdentifier: data.billing.LogisticsIdentifier,
      officeID:  data.billing.office.id,
      saleUserID: data.billing.salesId.id,
      vat: data.general.vat,
    }
  }
  // tslint:disable-next-line:no-any
  FormToDBSimple(data: CompanyForm , companyUuid: string): any  {
    return {
      blocked: data.billing.blocked,
      isGroupSiteInvoice: data.billing.groupBySite,
      companyUuid: companyUuid ,
    }
  }
  // tslint:disable-next-line:no-any
  FormToDBAddress(data: CompanyForm , companyUuid: string): any  {
    return {
      address: this.addressToDB(data.address),
      companyUuid: companyUuid ,
    }
  }
  // tslint:disable-next-line:no-any
  FormToDBContact(data: CompanyForm , companyUuid: string): any  {
    return {
      contact: data.contact,
      companyUuid: companyUuid ,
    }
  }
  // tslint:disable-next-line:no-any
  addressToDB(subForm: any): any {
    return {
      city: subForm.city,
      country: subForm.countryForm.name,
      id: subForm.id,
      line1: subForm.line1,
      line2: subForm.line2,
      line3: subForm.line3,
      name: subForm.name,
      state: subForm.state,
      uuid: subForm.uuid,
      zip: subForm.zip
    };
  }
}

